var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "offer-section" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "div",
            { staticClass: "offer-filter" },
            [
              _c("div", { staticClass: "toggler" }, [
                _c(
                  "button",
                  {
                    staticClass: "toggler-btn ",
                    class: { active: _vm.showfilter },
                    on: { click: _vm.showfilters }
                  },
                  [
                    _vm._v(_vm._s(_vm.showfilterText) + " "),
                    _c("img", {
                      attrs: { src: "/img/icon/arrow-down-black.svg", alt: "" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showfilter
                  ? _c("div", { staticClass: "main-filter open" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.closetoogleshow,
                                  expression: "closetoogleshow"
                                }
                              ],
                              staticClass: "filter-blck filter-dropdown"
                            },
                            [
                              _c("label", { staticClass: "min p-dgrey" }, [
                                _vm._v("Contract type")
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-white btn-full small dropdown",
                                  on: {
                                    click: function($event) {
                                      _vm.show = !_vm.show
                                    }
                                  }
                                },
                                [_vm._v("Sun, wind, water, Nature")]
                              ),
                              _vm._v(" "),
                              _c("transition", { attrs: { name: "fade" } }, [
                                _vm.show
                                  ? _c("div", { staticClass: "dropdown__el" }, [
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-list" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [
                                                _vm._v("Fixed price 6 months")
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [
                                                _vm._v("Fixed price 6 months")
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [
                                                _vm._v("Fixed price 6 months")
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [
                                                _vm._v("Fixed price 6 months")
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [
                                                _vm._v("Fixed price 6 months")
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.closetoogleshow2,
                                  expression: "closetoogleshow2"
                                }
                              ],
                              staticClass: "filter-blck filter-dropdown"
                            },
                            [
                              _c("label", { staticClass: "min p-dgrey" }, [
                                _vm._v("Contract type")
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-white btn-full small dropdown",
                                  on: {
                                    click: function($event) {
                                      _vm.show2 = !_vm.show2
                                    }
                                  }
                                },
                                [_vm._v("Some long text without dashes")]
                              ),
                              _vm._v(" "),
                              _c("transition", { attrs: { name: "fade" } }, [
                                _vm.show2
                                  ? _c("div", { staticClass: "dropdown__el" }, [
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-list" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    "/img/icon/weather/sun.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [_vm._v("Sun")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    "/img/icon/weather/wind.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [_vm._v("Wind")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    "/img/icon/weather/drop.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [_vm._v("Water")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    "/img/icon/weather/leaf.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [_vm._v("Nature")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    "/img/icon/weather/ecology.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [
                                                _vm._v(
                                                  "Good environmental choice"
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.closetoogleshow3,
                                  expression: "closetoogleshow3"
                                }
                              ],
                              staticClass: "filter-blck filter-dropdown"
                            },
                            [
                              _c("label", { staticClass: "min p-dgrey" }, [
                                _vm._v("Contract type")
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-white btn-full small dropdown",
                                  on: {
                                    click: function($event) {
                                      _vm.show3 = !_vm.show3
                                    }
                                  }
                                },
                                [_vm._v("All types")]
                              ),
                              _vm._v(" "),
                              _c("transition", { attrs: { name: "fade" } }, [
                                _vm.show3
                                  ? _c("div", { staticClass: "dropdown__el" }, [
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-list" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/img/icon/autogiro.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [_vm._v("Autogiro")]),
                                              _vm._v(
                                                "dw\n                                                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/img/icon/check.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [_vm._v("E-faktura")])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "dropdown-item" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/img/icon/file.svg",
                                                  alt: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      title: "title"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "box"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", [
                                                _vm._v("Traditionell")
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 col-lg-3 d-flex align-items-end justify-content-start"
                          },
                          [
                            _c("div", { staticClass: "filter-blck eco" }, [
                              _c("span", { staticClass: "checkbox" }, [
                                _c("input", {
                                  attrs: { type: "checkbox", title: "title" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "box" })
                              ]),
                              _vm._v(" "),
                              _c("label", { staticClass: "min-min p-dgrey" }, [
                                _vm._v("Good environmental choice")
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                attrs: { src: "/img/icon/ecology.svg", alt: "" }
                              })
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row justify-content-center" }, [
                        _c("div", { staticClass: "col-md-4 col-lg-3" }, [
                          _c(
                            "button",
                            { staticClass: "btn btn-blue btn-full small" },
                            [_vm._v("Apply filters")]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "offer-result" }, [
            _c("div", { staticClass: "title-row" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "col-xl-5" }, [
                  _c("div", { staticClass: "sort__blck" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.closetoogleshow4,
                            expression: "closetoogleshow4"
                          }
                        ],
                        staticClass: "filter-blck filter-dropdown"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-full btn-white small dropdown",
                            on: {
                              click: function($event) {
                                _vm.show4 = !_vm.show4
                              }
                            }
                          },
                          [_vm._v("Fixed price 1 year")]
                        ),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _vm.show4
                            ? _c("div", { staticClass: "dropdown__el" }, [
                                _c("div", { staticClass: "dropdown-list" }, [
                                  _c("div", { staticClass: "dropdown-item" }, [
                                    _vm._v("Fixed price 6 months")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-item" }, [
                                    _vm._v("Fixed price 6 months")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-item" }, [
                                    _vm._v("Fixed price 6 months ")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-item" }, [
                                    _vm._v("Fixed price 6 months")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-item" }, [
                                    _vm._v("Fixed price 6 months")
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "result__blck" }, [
              _c("div", { staticClass: "result_list" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "result_items" },
                  _vm._l(_vm.res, function(resultItem) {
                    return _c("offer-result", {
                      key: resultItem.id,
                      attrs: {
                        itemData: resultItem,
                        typeEnergy: resultItem.typeenergy
                      },
                      on: {
                        modalActive: function($event) {
                          return _vm.openModal()
                        }
                      }
                    })
                  }),
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "result_list" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "result_items" },
                  _vm._l(_vm.res2, function(resultItem) {
                    return _c("offer-result", {
                      key: resultItem.id,
                      attrs: { itemData: resultItem },
                      on: {
                        modalActive: function($event) {
                          return _vm.openModal()
                        }
                      }
                    })
                  }),
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "show-more p-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-blue small",
                    class: { load: _vm.preloaded },
                    attrs: { disabled: _vm.preloaded },
                    on: { click: _vm.preloadBlock }
                  },
                  [
                    _vm._v(
                      "\n                                Show more (Total: 95)\n                                    "
                    ),
                    _vm.preloaded
                      ? _c("span", [
                          _c("img", {
                            attrs: { src: "/img/tail-spin.svg", alt: "" }
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.modal
      ? _c("div", { staticClass: "info-popup open" }, [
          _c("div", {
            staticClass: "popupoverlay",
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mainpopup" }, [
            _c("div", {
              staticClass: "close",
              on: {
                click: function($event) {
                  return _vm.closeModal()
                }
              }
            }),
            _vm._v(" "),
            _vm._m(4)
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xl-7" }, [
      _c("p", { staticClass: "p-title relawayBold p-black" }, [
        _c("b", [_vm._v("Your result")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "Raleway min-med p-dgrey" }, [
        _vm._v("We found "),
        _c("b", [_vm._v("188")]),
        _vm._v(" electricity contracts that fit your preferences!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "Raleway med p-black mb-0" }, [
      _c("b", [_vm._v("Sort by:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result__title text-center" }, [
      _c("p", { staticClass: "p-center black med Raleway" }, [
        _c("b", [_vm._v("Fixed price 1 year")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result__title text-center" }, [
      _c("p", { staticClass: "p-center black med Raleway" }, [
        _c("b", [_vm._v("Fixed price 1 year")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_body" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway p-black max-max" }, [
          _c("b", [_vm._v("Info")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content min-min" }, [
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            " It is currently not possible to get our help with the change to this\n                        company, as they lack a cooperation with el skling.se."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                        The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                        environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next\n                        possible agreement in your list. For you it is "
          ),
          _c("b", [_vm._v("Skellefteå Kraft AB's")]),
          _vm._v(
            " 36 month agreement.\n                    The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an\n                    environmental agreement."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _c("b", [_vm._v("Would this agreement fit in instead?")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "submit__btn" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("button", { staticClass: "btn btn-gray btn-full small" }, [
              _vm._v("NO")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("button", { staticClass: "btn btn-green btn-full small" }, [
              _vm._v("AND")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }